import { request } from '@umijs/max';
import { isEmpty, omit } from 'lodash';

// 查询faq配置列表
export async function queryFaqService(data: any) {
  const { subject } = data;
  if (isEmpty(subject)) {
    return request('/bcare/faq/list', {
      method: 'POST',
      data,
    }).then((res) => {
      return request('/bcare/faq/list', {
        method: 'POST',
        data: omit(data, ['count', 'subject']),
      }).then((resData) => ({
        list: resData?.faqList[0]?.subjectList || [],
        total: res.totalCnt,
      }));
    });
  } else {
    return request('/bcare/faq/list/condition', {
      method: 'POST',
      data,
    }).then((resData) => ({
      list: resData?.faqList[0]?.subjectList || [],
      total: resData?.faqList[0]?.subjectList?.length,
    }));
  }
}

// 查询类别信息
export async function queryCategoryService(params: any) {
  const { pageIndex, pageCount } = params;
  return request(`/bcare/faq/category/list`, {
    params,
  }).then((res) => ({
    list: res?.categoryList || [],
    pageIndex: pageIndex + 1,
    pageCount,
  }));
}

// 创建类别
export async function addCategoryService(params: any) {
  return request(`/bcare/faq/category`, {
    params,
    method: 'PUT',
  });
}

// 删除类别
export async function deleteCategoryService(params: any) {
  return request(`/bcare/faq/category/delete`, {
    params,
    method: 'POST',
  });
}

// 新增new FAQ
export async function addSubjectService(data: any) {
  return request('/bcare/faq/content/add', {
    method: 'POST',
    data,
  });
}

// 修改 FAQ
export async function editSubjectService(data: any) {
  return request('/bcare/faq/content/mod', {
    method: 'POST',
    data,
  });
}

// 发布FAQ内容
export async function publishSubjectService(params: any) {
  return request(`/bcare/faq/content/publish`, {
    params,
    method: 'POST',
  });
}

// 删除FAQ内容
export async function delSubjectService(params: any) {
  return request(`/bcare/faq/content/delete`, {
    method: 'POST',
    params,
  });
}
